const categories = (state = [], action) => {
  switch (action.type) {
    case 'ADD_CATEGORIES':
      return action.categories;
    case 'REMOVE_CATEGORIES':
      return []
    default:
      return state
  }
}

export default categories;
